import { Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';



interface ChemicalCrop {
  id: string;
  pesticideCropName: string;
  linkedCropName: string | null;
  checked: boolean;
  processType?: string;
  cropId: string;
}

@Component({
    components: {
        Modal,
        EmptyGraphMessage
    }
})

export default class ChemicalCropLinkRegisterModal extends Vue {

    @Prop() 
    showChemicalCropLinkModal!: boolean

    @Prop()
    cropName?: string | null

    @Prop()
    id?: string | null

    isLoading = false;
    today = new Date().toISOString().split('T')[0];
    cropFamicId: string | null = null;

    private chemicalLinkedCrops : ChemicalCrop[] = []
    private chemicalCropList: ChemicalCrop[] = []
    private deletedCrops : ChemicalCrop[] = []
    private alteredModal = false
    private saveButtondisable = true

    private selectedType = 'ALL'
    private cropNameSearch?:string | null

    private sortOrder = true;


    baseUrl = '/chemical_crop_link_list';

    @Watch("showChemicalCropLinkModal")
    handlePopupOpening() {
        this.isLoading = true; 
        this.getLinkedCropsDetails();
        this.cropNameSearch = this.cropName
        this.isLoading = false;
        if(this.showChemicalCropLinkModal) this.$root.$emit('header-inert', true);
    }

    @Emit('inputChanged')
    inputChanged() {
        if(this.alteredModal == false){
            this.alteredModal = true
        }
    }

    closeModal() {
        if (this.alteredModal) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (result) {
                this.$emit('update:showChemicalCropLinkModal', false);
                this.alteredModal = false
            }
        }else{
           this.$emit('update:showChemicalCropLinkModal', false);
        }
        this.selectedType = 'ALL'
        this.$root.$emit('header-inert', false);
    }

    //紐づけ農薬用作物名
    async getLinkedCropsDetails(){
        const res = await this.$apiClient.doRequest("get", `${this.baseUrl}?crop_id=${this.id}`);
        this.chemicalLinkedCrops = res.chemicalCrops
        this.handleSearch();
    }


    //農薬用作物名
    async handleSearch(){
        const res = await this.$apiClient.doRequest("get", `${this.baseUrl}/search_list?crop_name=${this.cropNameSearch}&search_type=${this.selectedType}&crop_id=${this.id}`);
       
        const linkedCropNames = this.chemicalLinkedCrops.map((crop: ChemicalCrop) => crop.pesticideCropName)
        this.chemicalCropList = res.chemicalCropList
        .filter((crop: ChemicalCrop) => !linkedCropNames.includes(crop.pesticideCropName))
        .map((crop: ChemicalCrop) => ({
          ...crop,
          checked: false,
        }));
    }

    get sortedChemicalCrops(): ChemicalCrop[] {
        return this.chemicalLinkedCrops.slice().sort((a, b) => b.pesticideCropName.localeCompare(a.pesticideCropName));
    }

    //選択項目の追加
    addSelectedCrops() {
        const selected: ChemicalCrop[] = this.chemicalCropList
            .filter((crop: ChemicalCrop) => crop.checked)
            .map((crop: ChemicalCrop) => ({
                ...crop,
                processType: "add",
            }));
         this.chemicalLinkedCrops.push(...selected);
         this.chemicalCropList = this.chemicalCropList.filter((crop: ChemicalCrop) => !crop.checked);
         this.saveButtondisable = false;
    }

    async save(){
            try{
                let params = this.chemicalLinkedCrops;

                if (this.deletedCrops && this.deletedCrops.length > 0) {
                params = [...this.chemicalLinkedCrops, ...this.deletedCrops];
                }
                
                await this.$apiClient.doRequest("put", `${this.baseUrl}?crop_id=${this.id}`, params);
                this.$toasted.success('変更を保存しました。');
                this.deletedCrops = [];
                this.alteredModal = false
                this.saveButtondisable = true;
                this.closeModal()
                this.$root.$emit('header-inert', false);
            }catch (error) {
            this.$toasted.error('保存に失敗しました。');
            }
    }

    async deleteCrops(crop:any){
        this.inputChanged()
        this.saveButtondisable = false;
        crop.processType = "delete";
        this.deletedCrops.push(crop);
        this.chemicalLinkedCrops = this.chemicalLinkedCrops.filter(
            (item: any) => item.id !== crop.id
        );
        this.handleSearch()
    }

    private sort(pesticideCropName:  keyof ChemicalCrop): void {
    this.sortOrder = !this.sortOrder;

    this.chemicalCropList.sort((a, b) => {
        const aValue = a[pesticideCropName];
        const bValue = b[pesticideCropName];
        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;
        if (typeof aValue === 'string' && typeof bValue === 'string') 
            return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        if (typeof aValue === 'number' && typeof bValue === 'number') 
            return this.sortOrder ? aValue - bValue : bValue - aValue;
        return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
    });
 }
}